module.exports = __webpack_public_path__ + "static/media/AB_iPad_SE_EN.b7046e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_iPad_SE_EN.png
// module id = 115
// module chunks = 0